module.exports = __webpack_public_path__ + "static/img/jcj.1aee5e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/jcj.jpg
// module id = 5gHp
// module chunks = 0